import React from 'react';
import './general.css'
import { Link } from 'react-router-dom';
import err from '../asserts/err.png'
import Preloader from '../componets/layout/preloader';

const Error = () => {
    return ( <>
                <Preloader />

    <div className='error'>
        <img className='errimg' src={err} alt=''></img>
        404 Not Found! <br />
        WHYYYYY??
        
             <Link to="/home" className="no-underline-linkk">
             <button className='errorbtn'>Sorry , Go back</button>
</Link></div>
   

    </> );
}
 
export default Error;